import { Theme } from '@logto/schemas';

// Allguth forces light mode only; dark mode is intentionally never applied.
export const getThemeBySystemConfiguration = (): Theme => Theme.Light;

export default function useTheme() {
  // No-op: theme is always light, set statically in index.html and PageContext.
}
